import { IconFileSpreadsheet } from "@tabler/icons-react";
import type { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import type { ReportModule } from "src/common/service/ewr.js";
import { DashboardWidgetBase } from "./DashboardWidgetBase.js";

interface ReportsWidgetViewProps {
	modules: ReportModule[];
	ewrUrl: string;
	onOpenEwr: MouseEventHandler<HTMLAnchorElement>;
}

export const ReportsWidgetView = ({
	modules,
	ewrUrl,
	onOpenEwr,
}: ReportsWidgetViewProps) => {
	const { t } = useTranslation();

	return (
		<DashboardWidgetBase title={t("Reports")} flush>
			<ul>
				{modules.map((module) => (
					<li
						key={module.schema}
						className="border-b border-grey-200 last:border-b-0"
					>
						<a
							href={ewrUrl}
							target="_blank"
							rel="noopener noreferrer"
							onClick={onOpenEwr}
							className="group flex items-center gap-3 px-6 py-4"
						>
							<IconFileSpreadsheet
								size={20}
								className="shrink-0 text-brand-700"
							/>
							<span className="min-w-0 grow truncate text-sm font-semibold text-grey-900 group-hover:underline">
								{module.name}
							</span>
						</a>
					</li>
				))}
			</ul>
		</DashboardWidgetBase>
	);
};
